module.exports = __webpack_public_path__ + "static/media/r191.d4bcf12d.jpg";